import { render, staticRenderFns } from "./InvoiceDownPayment.vue?vue&type=template&id=b0690f7a"
import script from "./InvoiceDownPayment.vue?vue&type=script&lang=js"
export * from "./InvoiceDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports